import { Box } from '@chakra-ui/react';

import { TextBold } from 'UiKit/typography';
import { stockPromoText } from 'Const/stock-promo/view';

import styles from './styles.module.css';

const Head = () => {
  return (
    <Box className={styles['head__container']}>
      <TextBold className={styles['head__title--text']}>{stockPromoText.title}</TextBold>
    </Box>
  );
};

export default Head;
